// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".social-post-preview-image[data-v-75ccb4c5]{background:#e5e8ec;display:flex;align-items:center;justify-content:center;position:relative}.social-post-preview-image--loading[data-v-75ccb4c5]{min-height:300px}.social-post-preview-image__loader[data-v-75ccb4c5]{position:absolute;top:0;left:0;right:0;bottom:0;background:hsla(0,0%,98%,.9);display:flex;align-items:center;justify-content:center}.social-post-preview-image__src[data-v-75ccb4c5]{width:100%}", ""]);
// Exports
module.exports = exports;
